import { trimArray } from "@perxis-auto/shared";
import { instanceOfReference } from "@perxis-auto/shared/lib/lib/instanceOf";
import { selectAllFilterValues } from "../../../filterValues/model/selectors/selectAllFilterValues.js";
import "../../../filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../filterValues/model/selectors/selectFilterItems.js";
import "../../../filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { COLLECTION_IDS } from "../../../../shared/config/collections.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../../shared/store/reference/model/index.js";
import { selectFilterValues } from "./selectFilterValues.js";
const selectSlugedFilterValues = createAppSelector(
  [selectAllFilterValues, selectFilterValues, (state) => selectors.selectAll(state.reference)],
  (allFilterValues, filterValuesChoice, references) => {
    var _a;
    const slugedFilterValuesChoice = {};
    const { data: allFilterValuesItem } = allFilterValues;
    for (const [filterKey, filterValues] of Object.entries(filterValuesChoice)) {
      const allFilterValues2 = (_a = allFilterValuesItem == null ? void 0 : allFilterValuesItem.data) == null ? void 0 : _a[filterKey];
      const arrayedAllFilterValues = Array.isArray(allFilterValues2) ? allFilterValues2 : trimArray([allFilterValues2]);
      if (instanceOfReference(arrayedAllFilterValues == null ? void 0 : arrayedAllFilterValues[0])) {
        const extFilterReferenceValues = arrayedAllFilterValues;
        if (Array.isArray(filterValues)) {
          slugedFilterValuesChoice[filterKey] = trimArray(
            filterValues.map((value) => {
              const extFilterReferenceValue = extFilterReferenceValues.find((ref) => ref.id === value);
              return (extFilterReferenceValue == null ? void 0 : extFilterReferenceValue.slug) ?? (extFilterReferenceValue == null ? void 0 : extFilterReferenceValue.id);
            })
          );
        } else {
          const extFilterReferenceValue = extFilterReferenceValues.find((ref) => ref.id === filterValues);
          if ((extFilterReferenceValue == null ? void 0 : extFilterReferenceValue.collection_id) !== COLLECTION_IDS.dealersClusters) {
            slugedFilterValuesChoice[filterKey] = (extFilterReferenceValue == null ? void 0 : extFilterReferenceValue.slug) ?? (extFilterReferenceValue == null ? void 0 : extFilterReferenceValue.id);
          }
        }
      } else if (Array.isArray(filterValues)) {
        slugedFilterValuesChoice[filterKey] = trimArray(
          filterValues.map((value) => {
            const referenceValue = references.find((ref) => ref.id === value);
            return (referenceValue == null ? void 0 : referenceValue.data.slug) ?? (referenceValue == null ? void 0 : referenceValue.id) ?? value;
          })
        );
      } else {
        const referenceValue = references.find((ref) => ref.id === filterValues);
        slugedFilterValuesChoice[filterKey] = (referenceValue == null ? void 0 : referenceValue.data.slug) ?? (referenceValue == null ? void 0 : referenceValue.id) ?? filterValues;
      }
    }
    return slugedFilterValuesChoice;
  }
);
export {
  selectSlugedFilterValues
};
